export const companyTableOfClusterDetail = {
    multiSort: '※Shiftを押しながら各項目をクリックすると複数項目で並べ替えできます。',
    favoriteCompanyList: 'お気に入り企業一覧',
    searchAll: 'すべて検索',
    userInputPlaceholder: 'キーワードを入力してください',
    clusterId: 'クラスタID',
    companyName: '企業名',
    naceCode: '産業分類コード（NACE）',
    naceLabel: '産業分類ラベル',
    naceCodeAndLabel: '産業分類 (NACE)',
    registeredCountry: '登録国',
    mostFrequentIpc: '最頻IPC',
    score: 'スコア',
    numberOfPatentApplications: '特許出願数',
    numberOfMaterialPatents: '重要特許数',
    materialPatentRate: '重要特許率',
    numberOfForwardCitations: '被引用数',
    revenue: '事業規模 [百万米ドル]',
    minorityInvestmentAmount: 'マイノリティ出資額 [百万円]',
    startup: 'スタートアップ'
}
